import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { axiosPrivateInstance } from 'libs/axios';

import { GET_ALL_MANUFACTURE_LOCATION } from 'utils/serviceUrls';
import { ERROR } from 'utils/constants';

import { useAppDispatch } from 'hooks/stateHooks';
import { setMessage, setNotificationType, setShowNotification } from 'slices/roleModuleSlice';

const useGetAllManufactureLocations = (encManufacturerID: string) => {
	const dispatch = useAppDispatch();
	const { t } = useTranslation('productModule');

	const [manufacturerLocationRes, setManufacturerLocationRes] = useState<any>([]);
	const [manufacturerLocationsLoading, setManufacturerLocationsLoading] =
		useState<boolean>(false);

	const ApiRespone = async (manufactureId) => {
		setManufacturerLocationsLoading(true);

		// eslint-disable-next-line no-unused-vars
		await axiosPrivateInstance
			.post(GET_ALL_MANUFACTURE_LOCATION, { encParentManufacturerId: manufactureId })
			.then((response: any) => {
				if (response?.output && response?.status) {
					setManufacturerLocationRes(response?.output);
				} else {
					dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
					dispatch(setShowNotification(true));
					dispatch(setNotificationType(ERROR));
				}
			})
			.catch(() => {
				dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
				dispatch(setShowNotification(true));
				dispatch(setNotificationType(ERROR));
			})
			.finally(() => {
				setManufacturerLocationsLoading(false);
			});
	};

	useEffect(() => {
		if (encManufacturerID) {
			ApiRespone(encManufacturerID);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [encManufacturerID]);

	return {
		manufacturerLocationRes,
		manufacturerLocationsLoading,
	};
};

export default useGetAllManufactureLocations;
